export const SCHEDULES_ENDPOINT =
  '/p/v1/schedules/:scheduleId?include=holidays';
